/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TransactionCreate = {
    properties: {
        postedDate: {
            type: 'string',
            isNullable: true,
            format: 'date-time',
        },
        districtId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        billingAccountId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        originTransactionId: {
            type: 'string',
            isNullable: true,
            format: 'uuid',
        },
        paymentProcessor: {
            type: 'PaymentProcessorEnum',
            isRequired: true,
        },
        paymentType: {
            type: 'PaymentTypeEnum',
            isRequired: true,
        },
        primaryRefId: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
        secondaryRefId: {
            type: 'string',
            isNullable: true,
        },
        paymentTransactionType: {
            type: 'PaymentTransactionTypeEnum',
            isRequired: true,
        },
        amount: {
            type: 'number',
            isRequired: true,
            format: 'double',
        },
        serviceFeeAmount: {
            type: 'number',
            isRequired: true,
            format: 'double',
        },
        approvalCode: {
            type: 'string',
            isNullable: true,
        },
        createdAt: {
            type: 'string',
            isNullable: true,
            format: 'date-time',
        },
        tokenCreate: {
            type: 'TokenCreatePayment',
        },
        channel: {
            type: 'PaymentChannel',
        },
        batchNumber: {
            type: 'number',
            isNullable: true,
            format: 'int64',
        },
        checkNumber: {
            type: 'number',
            isNullable: true,
            format: 'int64',
        },
        allowedAction: {
            type: 'AllowedAction',
        },
    },
};